import { render, staticRenderFns } from "./FlawModal.vue?vue&type=template&id=6560975a&scoped=true"
import script from "./FlawModal.vue?vue&type=script&lang=js"
export * from "./FlawModal.vue?vue&type=script&lang=js"
import style0 from "./FlawModal.vue?vue&type=style&index=0&id=6560975a&prod&lang=scss"
import style1 from "./FlawModal.vue?vue&type=style&index=1&id=6560975a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560975a",
  null
  
)

export default component.exports